import { useInterval } from 'ahooks';
import Logo from 'components/navigation/Logo';
import { Progress } from 'components/ui/progress';
import { useState } from 'react';
import PercentUtils from 'utils/PercentUtils';

const NB_OF_INCREMENT = 7;
const LOADING_TIME = 4000;

export type PageLoaderProps = {
  loadingTime?: number;
  text?: string;
};

const PageLoader: React.FC<PageLoaderProps> = ({
  loadingTime = LOADING_TIME,
  text = undefined as string | undefined,
}) => {
  const { intervalTime, incrementPercentage } = PercentUtils.getTimePercentage(loadingTime, NB_OF_INCREMENT);

  // State
  const [percent, setPercent] = useState(0);

  // Hooks
  useInterval(() => {
    setPercent(percent + incrementPercentage);
  }, intervalTime);

  return (
    <div className="absolute inset-0 -z-10 flex flex-col items-center justify-center overflow-hidden">
      <Logo />
      {/* The increments overshoot 100 on the last tick; Radix treats an out-of-range value as indeterminate. */}
      <Progress value={Math.min(percent, 100)} className="w-72 mt-6" />
      {text || undefined}
    </div>
  );
};
export default PageLoader;
